/**
 * Admin V3 — commercial backlog hook (F2/F3)
 *
 * Single frontend consumer of the ONE backend source of truth
 * (GET /admin/commercial/work-queue/summary). Powers both the dashboard
 * backlog card (F2) and the sidebar work-queue badge (F3).
 *
 * Dark by default: gated behind VITE_COMMERCIAL_WORKQUEUE_VISIBILITY (mirrors
 * the project's dark-launch discipline). When OFF, the hook makes NO request
 * and reports enabled=false + zero counts, so the dashboard/badge stay dormant
 * until activation. When ON, it polls every 30s (reuses the proven
 * useAdminQuery refetchInterval polling).
 */
import useAdminQuery from './useAdminQuery';

const POLL_MS = 30000;
const ZERO = { accepted_devis: 0, draft_bdc: 0, awaiting_schedule: 0, total: 0 };

export const commercialWorkqueueEnabled = () =>
  import.meta.env.VITE_COMMERCIAL_WORKQUEUE_VISIBILITY === 'true';

const useCommercialBacklog = () => {
  const enabled = commercialWorkqueueEnabled();
  const { data } = useAdminQuery(
    '/admin/commercial/work-queue/summary',
    {},
    { enabled, refetchInterval: enabled ? POLL_MS : 0 },
  );
  return { enabled, summary: data || ZERO };
};

export default useCommercialBacklog;
